<script setup lang="ts">
import { useCmsSection } from "@shopware/composables";
import type { CmsSectionSidebar } from "@shopware/composables";
import { getTranslatedProperty } from "@shopware/helpers";
import { computed } from "vue";
import { useCategory } from "#imports";
import { useSidebarStore } from "@/stores/sidebar";

const props = defineProps<{
  content: CmsSectionSidebar;
}>();
const { getPositionContent } = useCmsSection(props.content);

const sidebarBlocks = getPositionContent("sidebar");
const mainBlocks = getPositionContent("main");
const mobileBehavior = computed(() => props.content.mobileBehavior);
const { category } = useCategory();
const isProductList = computed(
  () => category.value?.cmsPage?.type == "product_list"
);

const sidebarStore = useSidebarStore();
// Function to open sidebar (similar to product listing)
const openSidebar = () => {
  sidebarStore.openSidebar();
};

const closeSidebar = () => {
  sidebarStore.closeSidebar();
}
</script>

<template>
  <!-- <div class="cms-section-sidebar grid grid-cols-12 md:grid" v-if="!isProductList">
    <div class="col-span-12 mx-8 md:mx-5 mt-8">
      <h1 class="text-4xl font-extrabold tracking-tight text-gray-900">
        {{ getTranslatedProperty(category, "name") }}
      </h1>
    </div>
    <div class="col-span-12 md:col-span-7 lg:col-span-9 order-1 md:order-2">
      <CmsGenericBlock
        v-for="cmsBlock in mainBlocks"
        :key="cmsBlock.id"
        :content="cmsBlock"
      />
    </div>
    <div
      :class="{
        'align-top col-span-12 md:col-span-5 lg:col-span-3 order-2 md:order-1':
          mobileBehavior !== 'hidden',
        'hidden md:block': mobileBehavior === 'hidden',
      }"
    >
      <CmsGenericBlock
        v-for="cmsBlock in sidebarBlocks"
        :key="cmsBlock.id"
        :content="cmsBlock"
      />
    </div>
  </div> -->
  <section class="cms-section-sidebar pb-12 md:pb-16">
    <div class="container">
      <div class="flex">
        <CmsGenericSidebarBlock
          v-for="cmsBlock in sidebarBlocks"
          :key="cmsBlock.id"
          :content="cmsBlock"
        />

        <div class="side-right w-full flex-1 min-w-0 overflow-hidden">
          <!-- Common Header for Mobile -->
          <div
            v-if="!isProductList"
            class="header flex justify-between items-center mb-8 lg:mb-0 lg:hidden"
          >
            <button
              class="flex justify-center items-center gap-3 lg:hidden w-full max-w-[130px] min-w-[100px] md:min-w-36 lg:min-w-56 h-[40px] lg:h-[44px] border border-grey-500 rounded-full px-6 md:px-4 py-1.5 md:py-2 focus:outline-none appearance-none cursor-pointer text-base lg:text-base font-mulish font-normal leading-none"
              aria-label="Seitenleiste umschalten"
              id="toggleSidebar"
              @click="openSidebar"
            >
              <i
                class="icon-filter text-md 2xl:text-xl 3xl:text-2xl"
                aria-hidden="true"
              ></i
              ><span class="whitespace-nowrap">
                {{ $t("sidebar.filter") }}
              </span>
            </button>
          </div>

          <main class="content-main w-full h-full lg:pl-7 xl:pl-10 border-0 lg:border-l lg:border-grey-100" aria-label="Produktauflistung">
            <CmsGenericBlock
              v-for="cmsBlock in mainBlocks"
              :key="cmsBlock.id"
              :content="cmsBlock"
            />
          </main>
        </div>
      </div>

      <div 
        v-if="sidebarStore.isSidebarOpen"
        class="overlay-close fixed inset-0 z-[10] bg-black opacity-50 lg:hidden"
        @click="closeSidebar"
      ></div>
    </div>
  </section>
</template>
